import { TwoColumnLayout } from '@factorialco/f0-react'
import type { PurchaseRequestDetailQuery } from 'generated/resources/graphql'
import { PurchaseRequestFragment } from 'generated/resources/graphql'

import PurchaseRequestApprovalTimeline from 'modules/procurement/components/purchaseRequests/PurchaseRequestApprovalTimeline'
import PurchaseRequestSummarySidebar from 'modules/procurement/pages/PurchaseRequestDetailPage/PurchaseRequestSummarySidebar'

type ApprovalsV2ApprovalTimelineEntry =
  PurchaseRequestDetailQuery['procurement']['approvalsTimelines'][number]['entries'][number]

interface Props {
  purchaseRequest: PurchaseRequestFragment
  timelineEntries: ApprovalsV2ApprovalTimelineEntry[]
}

const WorkflowApprovalLayout = ({ purchaseRequest, timelineEntries }: Props) => {
  const mainContent = (
    <PurchaseRequestApprovalTimeline
      approvalProcess={purchaseRequest?.approvalProcess}
      timelineEntries={timelineEntries}
    />
  )

  const sideContent = <PurchaseRequestSummarySidebar purchaseRequest={purchaseRequest} />

  return <TwoColumnLayout sideContent={sideContent}>{mainContent}</TwoColumnLayout>
}

export default WorkflowApprovalLayout
